import { ColumnInfo, ColumnInfoList, DisplaySetting } from 'components/shared/display_setting'
import { TableCell } from 'components/shared/widget'
import { Coupon } from 'entities/coupon'
import { ReactNode, useMemo } from 'react'
import { Form } from 'utils/hooks'
import { CouponViewModel } from 'view_models/coupon_view_model'

export const couponColumnInfoList = (form?: Form<Record<string, unknown>>): ColumnInfoList => {
    return {
        tableName: '',
        values: [
            { name: 'ID', th: true, width: 40, form: form, orderAttr: 'coupon_id', searchType: { name: 'id', type: 'multiple_text' } },
            { name: '名称', th: true, width: 250, form: form, orderAttr: 'coupon_name', searchType: { name: 'name', type: 'text' } },
            {
                name: '割引額',
                align: 'center',
                th: true,
                width: 100,
                form: form,
                orderAttr: 'coupon_discount_price',
                searchType: { name: 'discountPrice', type: 'number' },
            },
            {
                name: '割引率',
                align: 'center',
                th: true,
                width: 70,
                form: form,
                orderAttr: 'coupon_discount_rate',
                searchType: { name: 'discountRate', type: 'number' },
            },
            {
                name: 'コード発行数',
                align: 'center',
                th: true,
                width: 100,
            },
            {
                name: '備考',
                th: true,
                minWidth: 300,
                form: form,
                orderAttr: 'coupon_note',
                searchType: { name: 'note', type: 'text' },
            },
        ],
    }
}

export type CouponTableDataProps = {
    coupon?: Coupon
    displaySetting: DisplaySetting
}

export const CouponTableData = ({ coupon, displaySetting }: CouponTableDataProps): JSX.Element => {
    if (!coupon) {
        return (
            <>
                {displaySetting.columnInfoList.values.map((_: ColumnInfo, index: number) => {
                    if (displaySetting.hiddenList.includes(index)) {
                        return <></>
                    } else {
                        return <TableCell key={index}></TableCell>
                    }
                })}
            </>
        )
    }
    const vm = new CouponViewModel(coupon)

    const createCells = useMemo(() => {
        return (
            <>
                <TableCell>{coupon.id}</TableCell>
                <TableCell>{coupon.name}</TableCell>
                <TableCell align="center">{vm.discountPrice()}</TableCell>
                <TableCell align="center">{vm.discountRate()}</TableCell>
                {coupon.hasCode ? (
                    <TableCell align="center" unit="枚">
                        <span>{coupon.couponCodeCount}</span>
                    </TableCell>
                ) : (
                    <TableCell align="center">発行しない</TableCell>
                )}

                <TableCell>{coupon.note}</TableCell>
            </>
        )
    }, [displaySetting.hiddenList])

    return createCells.props.children.filter((_: ReactNode, index: number) => !displaySetting.hiddenList?.includes(index)).map((cell: ReactNode) => cell)
}
